import React, { useCallback, useEffect, useState } from 'react';
import style from './style/sucessfulorder.module.css';
import sucessimg from '../images/sucessfull.png'
import { NavLink, useLocation } from 'react-router-dom';

const Sucessfulpurchase = () => {
    const location = useLocation();
    const [id,setId] = useState('');
    let orderid = location.state;
    const getId = useCallback(() =>{
        setId(orderid);
    },[orderid]);

    useEffect(()=>{
        getId();
    },[getId])
    return (
        <>
            <div className={style.box}>
                <img src={sucessimg} alt="Orderplaced" />
                <h1>Thank you</h1>
                <h1>Your Order Successdully Placed</h1>
                <h2 style={{color:'blue',marginTop:'15px'}}>OrderID:- '<span style={{color:'green'}}>{id}</span>'</h2>
                <p>( <span style={{color:'red'}} >please note this  for future reference</span> )</p>

                <NavLink style={{margin:'10px'}} to='/products'>Continue to shopping</NavLink>
            </div>
        </>
    )
}

export default Sucessfulpurchase;
